'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../IconSvg/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Selectable = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Selectable, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Selectable);

  function Selectable() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Selectable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleSelect", function (event) {
      event.preventDefault();

      _this.props.onSelect(_this.props.value, _this.props.label);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Selectable, [{
    key: "buttonClasses",
    value: function buttonClasses() {
      var classNames = [].concat(_rollupPluginBabelHelpers.toConsumableArray(this.props.classNames), ['ds-selectable-button']);

      if (this.props.selected) {
        classNames.push('selected');
      }

      return classNames.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        onClick: this.handleSelect,
        className: this.buttonClasses()
      }, this.props.label, this.props.showStatusMarker && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-selectable-status-marker ".concat(this.props.selected ? 'ds-selectable-status-marker--selected' : '')
      }, this.props.selected && /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-selectable-status-marker-icon",
        icon: "tick"
      })));
    }
  }]);

  return Selectable;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(Selectable, "propTypes", {
  classNames: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  label: PropTypes__default['default'].string.isRequired,
  onSelect: PropTypes__default['default'].func.isRequired,
  selected: PropTypes__default['default'].bool,
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]).isRequired,
  showStatusMarker: PropTypes__default['default'].bool
});

_rollupPluginBabelHelpers.defineProperty(Selectable, "defaultProps", {
  classNames: [],
  selected: false,
  showStatusMarker: false
});

module.exports = Selectable;
